import { Tabs, Tab } from "@mui/material";

interface UsersTabsProps {
  tab: "active" | "inactive";
  onChange: (value: "active" | "inactive") => void;
}

export default function UsersTabs({ tab, onChange }: UsersTabsProps) {
  return (
    <Tabs
      value={tab}
      onChange={(_, v) => onChange(v)}
      variant="fullWidth"
      sx={{
        borderBottom: "1px solid #f2f2f2",
        minHeight: 48,
        "& .MuiTab-root": {
          fontSize: 13,
          textTransform: "none",
          fontWeight: 500,
          color: "#666",
          "&.Mui-selected": { color: "#000" },
        },
        "& .MuiTabs-indicator": {
          backgroundColor: "#000",
          height: 2,
        },
      }}
    >
      <Tab value="active" label="Activos" />
      <Tab value="inactive" label="Inactivos" />
    </Tabs>
  );
}
